export default __webpack_public_path__ + "assets/689276fbc99d890fc1d896fceb131f0e.jpeg";